<template>
  <van-popup
    v-model="visible"
    position="bottom"
    closeable
  >
    <div class="reason-box">
      <div class="reason-title">退款原因</div>
      <div class="reason-content">
        <van-radio-group v-model="reasonForm.refundReasonCode">
          <div
            v-for="item in reasonList"
            :key="item.key"
            class="reason-item"
            @click="reasonForm.refundReasonCode = item.key"
          >
            <div class="item-label">{{item.description}}</div>
            <div class="item-radio">
              <van-radio :name="item.key" checked-color="#ff3d2d"></van-radio>
            </div>
          </div>
        </van-radio-group>
        <div 
          v-if="['OTHER','OTHER_PASS'].includes(reasonForm.refundReasonCode)"
          class="reason-other"
        >
          <input
            v-model="reasonForm.refundReasonDesc"
            placeholder="请输入其他原因"
            type="text"
            class="reason-input"
            maxlength="20"
          >
        </div>
      </div>
      <div class="reason-btn">
        <nd-button
          :disabled="disabled"
          @click="handleChooseReason"
        >完成</nd-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, RadioGroup, Radio } from 'vant'

export default {
  name: 'RefundReason',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    reasonList: {
      type: Array,
      default: () => []
    },
    // 传入进来的原因key，需要带上.sync操作符
    reasonCode: {
      type: String,
      default: ''
    },
    // 传入进来的原因描述，需要带上.sync操作符
    reasonDesc: {
      type: String,
      default: ''
    }
  },
  components: {
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  data () {
    return {
      reasonForm: {
        refundReasonCode: '',
        refundReasonDesc: ''
      }
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    disabled () {
      return this.reasonForm.refundReasonCode === '' || (['OTHER', 'OTHER_PASS'].includes(this.reasonForm.refundReasonCode) && this.reasonForm.refundReasonDesc === '')
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.reasonForm.refundReasonCode = this.reasonCode
      }
    }
  },
  methods: {
    handleChooseReason () {
      const { refundReasonCode } = this.reasonForm
      let refundReasonDesc = ''
      if (['OTHER', 'OTHER_PASS'].includes(refundReasonCode)) {
        refundReasonDesc = this.reasonForm.refundReasonDesc
      } else {
        refundReasonDesc = this.reasonList.find(item => item.key === refundReasonCode).description
      }
      this.$emit('update:reasonCode', this.reasonForm.refundReasonCode)
      this.$emit('update:reasonDesc', refundReasonDesc)
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

/deep/.van-popup__close-icon{
  font-size: 40px;
  top: 53px;
  right: 50px;
}
.reason-box{
  .reason-title{
    font-size: 36px;
    color: #333333;
    border-bottom: 1PX solid #eeeeee;
    padding: 50px;
    font-weight: bold;
  }
  .reason-content{
    .reason-item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 34px 50px;
      border-bottom: 1PX solid #eeeeee;
      .item-label{
        font-size: 30px;
        color: #333333;
      }
      .item-radio{
        font-size: 36px;
        /deep/.van-radio__icon{
          font-size: 36px;
        }
      }
    }
    .reason-other{
      padding: 34px 50px;
      border-bottom: 1PX solid #eeeeee;
      .reason-input{
        font-size: 30px;
        line-height: 30px;
        width: 100%;
        border: none;
      }
    }
  }
  .reason-btn{
    display: flex;
    justify-content: center;
    padding: 88px 0;
  }
}
</style>